export default function tabs() {

    const tabBtns = document.querySelectorAll('.js-tab-btn');
    const tabBoxes = document.querySelectorAll('.js-tab-box');

    const headerCalendarBtn = document.querySelector('.js-header-calendar-btn');
    const headerAbonimentBtn = document.querySelector('.js-header-aboniment-btn');

    if (tabBtns.length > 0 && tabBoxes.length > 0) {
        
        tabBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                let id = btn.dataset.box;
                console.log('', id);

                document.querySelector('.js-tab-btn.active')?.classList.remove('active');
                btn.classList.add('active');

                document.querySelector('.js-tab-box.active')?.classList.remove('active');
                document.querySelector(`.js-tab-box[data-box="${id}"]`)?.classList.add('active');

            })
        });

    }

    if (headerCalendarBtn && headerAbonimentBtn) {
        headerCalendarBtn.addEventListener('click', () => {
            if (document.querySelector('.js-tab-btn[data-box="1"]')){
                document.querySelector('.js-tab-btn[data-box="1"]').click();
            }

            document.querySelector('#content-page')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
        headerAbonimentBtn.addEventListener('click', () => {
            if (document.querySelector('.js-tab-btn[data-box="2"]')){
                document.querySelector('.js-tab-btn[data-box="2"]').click();
            }

            document.querySelector('#content-page')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    }

}